import React, { useEffect, useState } from 'react';
import { styled } from 'linaria/react';
import { theme } from '../../Theme';
import { FindifyRecommendations } from '../../Findify';

const NotificationCard = styled('div')`
  @keyframes desktopIn {
    0% {
      opacity: 0;
      transform: translateY(-2rem);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes mobileIn {
    0% {
      opacity: 0;
      transform: translateY(2rem);
    }
    100% {
      opacity: 1;
      transform: translateY(0);
    }
  }
  position: absolute;
  top: 2rem;
  right: 0;
  width: 434px;
  max-height: 80vh;
  animation-name: desktopIn;
  animation-duration: 0.4s;
  animation-fill-mode: backwards;

  &.exiting {
    pointer-events: none;
    opacity: 0;
    transform: translateY(-2rem);
    transition: all 0.4s;
  }

  ${theme.below.md} {
    position: relative;
    top: 0;
    width: 375px;
  }

  ${theme.below.xs} {
    position: absolute;
    top: auto;
    right: auto;
    left: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    max-height: 90vh;
    animation-name: mobileIn;
    &.exiting {
      transform: translateY(2rem);
    }
  }
`;

const AddedToCartCard = ({
  timeout,
  id,
  clear,
  state,
  exitDuration,
  children
}) => {
  const [keepAlive, setKeepAlive] = useState(false);
  let timer;
  useEffect(() => {
    if (!keepAlive && timeout) {
      timer = setTimeout(() => {
        clear(id, exitDuration);
      }, timeout);
    }
    return () => clearTimeout(timer);
  }, [keepAlive]);

  return (
    <NotificationCard
      className={state}
      onTouchStart={_ => setKeepAlive(true)}
      onTouchEnd={_ => setKeepAlive(false)}
      onMouseEnter={_ => setKeepAlive(true)}
      onMouseLeave={_ => setKeepAlive(false)}
    >
      {children}
    </NotificationCard>
  );
};

export default AddedToCartCard;
